import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  hasActiveTradeApplied: boolean;
  minDownPayment: number;
  minDownPaymentNoTrade?: number;
  tradeDown?: number;
  hasValidSoftPull: boolean;
};

const getDescriptor = ({
  hasValidSoftPull,
  minDownPayment,
  minDownPaymentNoTrade = minDownPayment,
  hasActiveTradeApplied,
  tradeDown = 0
}: OwnProps) => {
  const softPullText = hasValidSoftPull ? '' : 'estimated';

  if (hasActiveTradeApplied && tradeDown >= 0) {
    return minDownPayment > 0 && minDownPaymentNoTrade > minDownPayment
      ? `Your ${softPullText} minimum cash down of $${formatAndDropDecimal(
          minDownPayment
        )} has been partially satisfied by your trade-in offer`
      : `Your ${softPullText} minimum cash down has been satisfied by your trade-in offer.`;
  }

  return `Your ${softPullText} minimum cash down is $${formatAndDropDecimal(
    minDownPayment
  )}`;
};

export default function CashDownDescriptors(props: OwnProps) {
  return (
    <div className="cash-down-descriptors" data-qa="cash-down-descriptors">
      {getDescriptor(props)}
    </div>
  );
}
